import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
  CommonModule,
  CurrencyPipe,
  DatePipe,
  DecimalPipe,
} from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AngularPipesModule } from '@aptitude/angular-pipes';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { LoadingIndicatorComponent } from './loading-indicator/loading-indicator.component';
import { LoadingIndicatorDirective } from './loading-indicator/loading-indicator.directive';
import { LoadingMessageModalComponent } from './loading-message-modal/loading-message-modal.component';
import { LoadingMessageModalService } from './loading-message-modal/loading-message-modal.service';
import { CategoryStructureTooltipComponent } from './grid/category-structure-tooltip/category-structure-tooltip.component';
import { CarveInCurrencyCellRendererComponent } from './grid/cell-renderers/carve-in-currency-cell-renderer.component';
import { CookieManagerService } from '../../services/cookie-manager.service';
import { GridTooltipComponent } from './grid/grid-tooltip/grid-tooltip.component';
import { CustomOverlayNoRowsComponent } from './grid/overlay-no-rows/overlay-no-rows.component';
import { GridCheckboxComponent } from './grid/grid-checkbox/grid-checkbox.component';
import { GridClinicalAssessmentWrapperComponent } from './grid/grid-clinical-assessment-wrapper/grid-clinical-assessment-wrapper.component';
import { CustomLoadingOverlayComponent } from './grid/custom-loading-overlay.component';
import { DateCellEditorComponent } from './grid/date-cell-editor/date-cell-editor.component';
import { CrossReferenceAssessmentsModule } from './cross-reference-assessments/cross-reference-assessments.module';
import { CharacteristicsCellEditorComponent } from './grid/characteristics-cell-editor/characteristics-cell-editor.component';
import { GridToggleComponent } from './grid/grid-toggle/grid-toggle.component';
import { GridTierSelectorComponent } from './grid/grid-tier-selector/grid-tier-selector.component';
import { TierSelectionModule } from './grid/grid-tier-selector/modals/tiers-selection.module';
import { TestIdDirective } from './test-id/test-id.directive';
import { GridVizientAssessmentWrapperComponent } from './grid/grid-vizient-assessment-wrapper/grid-vizient-assessment-wrapper.component';
import { TextOverflowComponent } from './text-overflow/text-overflow.component';
import { SoloOrGroupIconComponent } from './solo-or-group-icon/solo-or-group-icon.component';
import { HomeCardViewPipe } from './home-card-view.pipe';
import { AsyncEmailValidatorDirective } from './email-input-validator.directive';
import { PhoneValidatorDirective } from './phone-input-validator.directive';
import { DatePickerInputValidatorDirective } from './date-picker-input-validator.directive';
import { CategoryNameValidatorDirective } from './category-name-validator.directive';
import { CategoryCellRendererWrapperComponent } from './grid/category-cell-renderer-wrapper/category-cell-renderer-wrapper.component';
import { CategoryPathCellRendererComponent } from './grid/cell-renderers/category-path-cell-renderer.component';
import { LinkWithTextBodyCellRendererComponent } from './grid/cell-renderers/link-with-text-body-cell-renderer.component';
import { SpanWithTextBodyCellRendererComponent } from './grid/cell-renderers/span-with-text-body-cell-renderer.component';
import { LinkAndIconCellRendererComponent } from './grid/cell-renderers/link-and-icon-cell-renderer';
import { LinkWithDescriptionCellRendererComponent } from './grid/cell-renderers/link-with-description-cell-renderer';
import { DecimalPlacesValidatorDirective } from './decimal-places-validator.directive';

@NgModule({
  declarations: [
    HomeCardViewPipe,
    TextOverflowComponent,
    CharacteristicsCellEditorComponent,
    LoadingIndicatorComponent,
    LoadingIndicatorDirective,
    LoadingMessageModalComponent,
    CategoryStructureTooltipComponent,
    GridCheckboxComponent,
    GridTooltipComponent,
    GridClinicalAssessmentWrapperComponent,
    CustomOverlayNoRowsComponent,
    CustomLoadingOverlayComponent,
    DateCellEditorComponent,
    GridToggleComponent,
    GridTierSelectorComponent,
    TestIdDirective,
    GridVizientAssessmentWrapperComponent,
    SoloOrGroupIconComponent,
    AsyncEmailValidatorDirective,
    PhoneValidatorDirective,
    DatePickerInputValidatorDirective,
    CategoryNameValidatorDirective,
    CarveInCurrencyCellRendererComponent,
    CategoryCellRendererWrapperComponent,
    CategoryPathCellRendererComponent,
    LinkWithTextBodyCellRendererComponent,
    SpanWithTextBodyCellRendererComponent,
    LinkAndIconCellRendererComponent,
    LinkWithDescriptionCellRendererComponent,
    DecimalPlacesValidatorDirective,
  ],
  imports: [
    CommonModule,
    AngularPipesModule,
    CrossReferenceAssessmentsModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    TierSelectionModule,
  ],
  exports: [
    TextOverflowComponent,
    HomeCardViewPipe,
    LoadingIndicatorComponent,
    LoadingIndicatorDirective,
    LoadingMessageModalComponent,
    CategoryStructureTooltipComponent,
    GridCheckboxComponent,
    GridTooltipComponent,
    GridClinicalAssessmentWrapperComponent,
    GridToggleComponent,
    GridTierSelectorComponent,
    GridVizientAssessmentWrapperComponent,
    TestIdDirective,
    AsyncEmailValidatorDirective,
    PhoneValidatorDirective,
    DatePickerInputValidatorDirective,
    CategoryNameValidatorDirective,
    CarveInCurrencyCellRendererComponent,
    CategoryCellRendererWrapperComponent,
    CategoryPathCellRendererComponent,
    LinkWithTextBodyCellRendererComponent,
    SpanWithTextBodyCellRendererComponent,
    LinkAndIconCellRendererComponent,
    LinkWithDescriptionCellRendererComponent,
    DecimalPlacesValidatorDirective,
  ],
  providers: [
    CookieManagerService,
    CurrencyPipe,
    DecimalPipe,
    DatePipe,
    LoadingMessageModalService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UtilSharedModule {}
